//SHARED FILE : USED ON DETAILS AND PRODUCT LIST AND CART
//ANY CHANGES SHOULD BE TESTED ON ALL PAGES
var favoriteHelper = function(){
	var animations = new animations4i();
	
	var checkProdFav = function(){
		if(document.getElementsByClassName('favPrintIcons')[0]){
			var favIcons = [].slice.call(document.getElementsByClassName('favPrintIcons'));
			if(favIcons[0].classList.contains('mobileList')){
				//mobile list page - not needed on new list page
				//checkBulkProdsFav();
			}else{
				//details page
				checkDetailsPage(favIcons[0]);
			}	
		}
	}, 
	checkBulkProdsFav = function(){
		
		if(document.getElementsByClassName('favPrintIcons')[0]){
            var prodsInBoardsRequest = ajax({
                method: "POST",
                url: "/Product/BulkFaveItemsAsync",
            });
            prodsInBoardsRequest.then(function (response) {
				//var favIcons = [].slice.call(document.getElementsByClassName('favPrintIcons'));
                if (response.success == true){
					var favedItems = response.data;
					//favIcons.forEach(function(el, index){
						var favLinkProd = [].slice.call(document.getElementsByClassName("faveLinkProdID"));
						favLinkProd.forEach(function (el) {
							var productID = el.value; 
							if (typeof(favedItems) !== 'undefined' && favedItems && favedItems.includes(parseInt(productID))){
								el.parentNode.getElementsByClassName('faveLink')[0].classList.remove("textDkGray");
								el.parentNode.getElementsByClassName('faveLink')[0].classList.add("textRed");
							}else{
								el.parentNode.getElementsByClassName('faveLink')[0].classList.remove("textRed");
								el.parentNode.getElementsByClassName('faveLink')[0].classList.add("textDkGray");
							}
						});
					//});
                }else{
					// do nothing in case it had errored out but the icons had been set server side
					// favLinkProd.forEach(function (el, index, array) {
					// 	var productID = el.value;
					// 	if (typeof(favedItems) !== 'undefined' && favedItems.contains(productID)){
					// 		el.parentNode.getElementsByClassName('faveLink')[0].classList.remove("textDkGray");
					// 		el.parentNode.getElementsByClassName('faveLink')[0].classList.add("textRed");
					// 	}else{
					// 		el.parentNode.getElementsByClassName('faveLink')[0].classList.remove("textRed");
					// 		el.parentNode.getElementsByClassName('faveLink')[0].classList.add("textDkGray");
					// 	}
					// });
				}
			});

           
		}
	},
	checkDetailsPage = function(el){
		var productID = (typeof (prodID) == 'undefined') ? el.querySelectorAll(".faveLinkProdID")[0].value : prodID;
		var data = { productID: productID };
		var listInBoardRequest = ajax({
			method: "POST",
			url: "/Product/IsItemInBoardAsync",
			data: data
		});
		listInBoardRequest.then(function (response) {
			if (response.success == true){
				var favItems = [].slice.call(document.getElementsByClassName('favoriteItem'));
				favItems.forEach(function(el){
					el.classList.remove("textDkGray");
					el.classList.add("textRed");
				});
			}else{
				var favItems = [].slice.call(document.getElementsByClassName('favoriteItem'));
				favItems.forEach(function(el){
					el.classList.add("textDkGray");
					el.classList.remove("textRed");
				});
			}
		});
		
		//details page is for both mobile and www, resulting in it having 2 fav icons for the same product.
		//removed/changed this bit to kill that second call

		// favIcons.forEach(function(el){
		// 	var productID = (typeof (prodID) == 'undefined') ? el.querySelectorAll(".faveLinkProdID")[0].value : prodID;
		// 	var data = { productID: productID };
		// 	var listInBoardRequest = ajax({
		// 		method: "POST",
		// 		url: "/Product/IsItemInBoardAsync",
		// 		data: data
		// 	});
		// 	listInBoardRequest.then(function (response) {
		// 		if (response.success == true){
		// 			document.getElementsByClassName('favoriteItem')[0].classList.remove("textDkGray");
		// 			document.getElementsByClassName('favoriteItem')[0].classList.add("textRed");
		// 		}else{
		// 			document.getElementsByClassName('favoriteItem')[0].classList.remove("textRed");
		// 			document.getElementsByClassName('favoriteItem')[0].classList.add("textDkGray");
		// 		}
		// 	});

		// })
	},
	favEvents = function(){
		existingBoardEvents();
		
		if(document.getElementsByClassName('cancel-new-board')[0]){ //on detail and list
			document.getElementsByClassName('cancel-new-board')[0].addEventListener("click", function () {
				var form = this.closest('#newBoardForm');
				form.classList.add('slideLeft');
				animations.slideUp(form.getElementsByClassName('ErrorMsgPanel')[0]); 
				form.getElementById('BoardName').removeAttribute('style');
				setTimeout(function () {
					form.parentNode.removeChild(form);
				}, 250);
				document.getElementsByClassName('create-board')[0].setAttribute('aria-expanded', 'false');
				document.getElementsByClassName('saveAsFavBoard')[0].focus();
			});
		}
	   	var favLink = [].slice.call(document.getElementsByClassName('faveLink'));  //on detail and list
	   	favLink.forEach(function(el, index, array){
			el.addEventListener('click', function (e) {
				e.preventDefault();
		    		el.parentNode.getElementsByClassName('ideaBoardList')[0].classList.add("slideDown");
		    		el.parentNode.getElementsByClassName('ideaBoardList')[0].classList.remove("hide");
		    		
		    		el.nextElementSibling.getElementsByClassName("cancelBoardList")[0].focus();
		    		el.parentNode.getElementsByClassName('ideaBoardList')[0].setAttribute("aria-hidden", "false");
		    		el.setAttribute("aria-expanded", "true");
			});
		});
		if(document.getElementsByClassName('saveAsFavBoard')[0]){ // on cart page
			document.getElementsByClassName('saveAsFavBoard')[0].addEventListener('click', function (e) {
				e.preventDefault();
				if(document.getElementsByClassName('cancel-new-board')[0]){
					document.getElementsByClassName('cancel-new-board')[0].click();
				}
				if(document.getElementsByClassName('newBoardMsg')[0]){
					document.getElementsByClassName('newBoardMsg')[0].parentNode.removeChild(document.getElementsByClassName('newBoardMsg')[0]);
				}
				if (this.classList.contains('registered')) {
					ajaxActions.GetBoardForm();
				} else {
					window.location = "/registration/login";
				}
			});
		}
		//omniture logging
		var viewProductLinks = [].slice.call(document.getElementsByClassName("viewProduct"));
		viewProductLinks.forEach(function(el, index, array){
			el.addEventListener("click", function(e){
				e.preventDefault();
				omniture().ViewProductClick();
				window.location = e.currentTarget.href;
			});
		});
		var cancelListBoards = [].slice.call(document.getElementsByClassName('cancelBoardList')); // list and details page
		cancelListBoards.forEach(function(el, index, array){
			el.addEventListener("click", function (e) {
				e.preventDefault();
				el.parentNode.classList.remove("slideDown");
				setTimeout(function(){
					el.parentNode.classList.add("hide");
				}, 500);
				el.parentNode.setAttribute("aria-hidden", "true");
		    		el.parentNode.previousElementSibling.setAttribute("aria-expanded", "false");
		    		el.parentNode.parentNode.getElementsByTagName('button')[0].focus();
		    		
				var addToBoardMsg = [].slice.call(document.getElementsByClassName('addToBoardMsg'));
				addToBoardMsg.forEach(function (el, index, array) {
					el.parentNode.removeChild(el);
				});
			});
		});
	}, 
	detailsFavEvents = function(){
		if(document.getElementsByClassName("cancel-delete-item")[0]){
			document.getElementsByClassName("cancel-delete-item")[0].addEventListener("click", function(e){
				e.preventDefault();
				var boardMsg = this.parentNode.parentNode;
				boardMsg.parentNode.removeChild(boardMsg);
			});
		}
		if(document.getElementsByClassName("confirm-delete-item")[0]){
			document.getElementsByClassName("confirm-delete-item")[0].addEventListener("click", function(e){
				e.preventDefault();
				var arr = this.getAttribute('href').split('/');
				ajaxActions.DeleteBoardItem(arr[0], arr[1], this);
			});
		}
	},
	existingBoardEvents = function(){
		var boardNames = [].slice.call(document.getElementsByClassName('boardName'));
		boardNames.forEach(function(el, index, array){
			el.addEventListener("click", function (e) {
				e.preventDefault();
				if(document.getElementsByClassName('addToBoardMsg')[0]){
					document.getElementsByClassName('addToBoardMsg')[0].parentNode.removeChild(document.getElementsByClassName('addToBoardMsg')[0]);
				}
				ajaxActions.AddToIdeaBoard(el);
			});
		});
	},
	cartBoardEvents = function(){
		existingBoardEvents();
		
		function removeBoardNameErrors(){
			document.getElementById("boardName").classList.remove("input-validation-error");
			document.getElementById("boardName").setAttribute("aria-invalid", "false");
			document.getElementById("boardName").parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
		}
		function validateBoardName(){
			document.getElementById("boardName").classList.add("input-validation-error");
			document.getElementById("boardName").setAttribute("aria-invalid", "true");
			document.getElementById("boardName").parentNode.getElementsByClassName("errorMessage")[0].classList.remove("hide");
			document.getElementById("boardName").focus();
		}
		document.getElementById('submitNewBoard').addEventListener("click", function (e) {
			e.preventDefault();
			removeBoardNameErrors();
			if(document.getElementById("boardName").value == ""){
				validateBoardName();
			}else{
				ajaxActions.CreateBoardWithCart();
			}
		});
		var cancelBoardBtns = [].slice.call(document.getElementsByClassName("cancelCartBoard"));
		cancelBoardBtns.forEach(function(el, index, array){
			el.addEventListener("click", function(e){
				e.preventDefault();
				document.getElementById('newBoardForm').parentNode.removeChild(document.getElementById('newBoardForm'));
				document.getElementsByClassName('saveAsFavBoard')[0].focus();
			});
		});
		
		document.getElementById('newBoardForm').addEventListener('keydown', function (e) {
           		if ((e.which || e.keyCode) === 27) { /*esc*/
                		document.getElementById('newBoardForm').parentNode.removeChild(document.getElementById('newBoardForm'));
                		document.getElementsByClassName('saveAsFavBoard')[0].focus();
            		}
        	});
        	//add cart items to existing board	
		var existingBoards = [].slice.call(document.getElementsByClassName('boardListItem'));
		existingBoards.forEach(function(el, index, array){
			el.addEventListener("click", function (e) {
				e.preventDefault();
				if(document.getElementsByClassName('addToBoardMsg')[0]){
					document.getElementsByClassName('addToBoardMsg')[0].parentNode.removeChild(document.getElementsByClassName('addToBoardMsg')[0]);
				}
				ajaxActions.AddCartItemsToBoard(el);
			});
		});
	},
	ajaxActions = (function(){
		var addToIdeaBoard = function (el) {
			var boardIDNumber = el.parentNode.getElementsByClassName('board-id')[0].value;
			var productID = (typeof (prodID) == 'undefined') ? el.closest('.favPrintIcons').querySelectorAll('.faveLinkProdID')[0].value : prodID;
			if (productID == null) {
				//still not found? try mobile details
				productID = document.getElementById('productid').value;
			}
			var data = { boardID: boardIDNumber, productID: productID };
			el.parentNode.getElementsByClassName('addItemLoading')[0].classList.remove("hide");
			var addItemBoardRequest = ajax({
				method: "POST",
				url: "/favs/additemtoboard",
				data: data
			});
			addItemBoardRequest.then(function (response, xhr) {
				el.parentNode.getElementsByClassName('addItemLoading')[0].classList.add("hide");
				//If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
	        		el.insertAdjacentHTML('afterend', response.message);
	        		if (response.success == "true") {
	            			el.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.remove('textDkGray');
	            			el.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.add('textRed');
	            			el.nextElementSibling.getElementsByTagName("a")[0].focus();
	            			detailsFavEvents();
	        		}
			});
		},
		deleteBoardItem = function(e, f, g) {
			var boardID = e;
			var boardItemID = f;
			var data = { boardID: boardID, boardItemID: boardItemID };
			g.parentNode.parentNode.parentNode.getElementsByClassName('addItemLoading')[0].classList.remove("hide");
		  	var deleteBoardItemRequest = ajax({
		  		method: "POST",
		  		url: '/favs/deleteboarditem',
		  		data: data
		  	});
		  	deleteBoardItemRequest.then(function (response, xhr) {
	                	g.parentNode.parentNode.parentNode.getElementsByClassName('addItemLoading')[0].classList.add("hide");
	                	if (response.isItemInOtherBoards == "False") {
	              		g.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.remove('textRed');
	              		g.closest('.favPrintIcons').getElementsByClassName('faveLink')[0].classList.add('textDkGray');
	          		}
	          		animations.slideUp(g.closest('.addToBoardMsg'));
	          		g.closest('.addToBoardMsg').parentNode.removeChild(g.closest('.addToBoardMsg'));
	            	});
		},
		getBoardForm = function() {
			document.getElementById("loading").classList.remove("hide");
			var boardFormRequest = ajax({
				method: "POST",
				url: '/favs/getcartboardform'
			});
			boardFormRequest.then(function (response, xhr) {
	                    document.getElementById("loading").classList.add("hide");
	                    var wrapper = document.createElement("div");
	                    wrapper.innerHTML = response;
	                    document.getElementById('mainContent').appendChild(wrapper);
	                    
	        		var saveAsFavorite = dialog4i();
	        		saveAsFavorite.init(document.getElementById('newBoardForm'));
	        		saveAsFavorite.open();
	        		document.getElementById('boardName').focus();
	        		cartBoardEvents();
	              });
		},
		createBoardWithCart = function() {
			var form = document.getElementById('newCartBoard');
		    	var boardName = form.querySelectorAll('#boardName')[0].value;
		    	var isDefaultBoard = form.querySelectorAll('#isDefaultBoard')[0].checked ? true : false;
		    	var note = form.querySelectorAll('#Notes')[0].value;
		    	var cartID = document.getElementById('UserCart_CartID').value;
		    	var data = { Name: boardName, CreatedDate: null, GURID: '', IsDefaultBoard: isDefaultBoard, Notes: note, CartID: cartID };
		  	
		  	var addNewBoard = ajax({
		  		method: "POST",
		  		url: '/favs/addnewboard',
		  		data: data
		  	});
		  	addNewBoard.then(function (response, xhr) {
		        	if (response.length > 1) {
		          		omniture().LogNewBoardCreation();
		          		var wrapperDiv = document.createElement("div");
		          		wrapperDiv.innerHTML = response;
		          		document.getElementById('newBoardForm').replaceWith(wrapperDiv);
		          		document.getElementsByClassName('newBoardMsg')[0].getElementsByTagName("a")[0].focus();
	        		}
	              });
		},
		addCartItemsToBoard = function(el) {
		    	var boardID = el.parentNode.getElementsByClassName('board-id')[0].value;
		    	var cartID = document.getElementById('UserCart_CartID').value;
		    	var data = { cartID: cartID, boardID: boardID };
		    	
		    	el.parentNode.getElementsByClassName('addItemLoading')[0].classList.remove("hide");
		  	var addCartItems = ajax({
		  		method: "POST",
		  		url: "/favs/addcartitemstoboard",
		  		data: data
		  	});
		  	addCartItems.then(function (response, xhr) {
	                   	el.parentNode.getElementsByClassName('addItemLoading')[0].classList.add("hide");
	                   	el.insertAdjacentHTML('afterend', response.message);
	                   	el.nextElementSibling.getElementsByTagName("a")[0].focus();
			});
		};
		
		return {
			AddToIdeaBoard: addToIdeaBoard,
			DeleteBoardItem: deleteBoardItem,
			GetBoardForm: getBoardForm,
			CreateBoardWithCart: createBoardWithCart,
			AddCartItemsToBoard: addCartItemsToBoard
		};
	})(),
	omniture = function () {
		var logNewBoardCreation = function () {
			var account = s_account ? s_account : "4imprintprod";
			var s = s_gi(account);
			if (typeof s != "undefined") {
	          		s.linkTrackVars = 'prop26';
	          		s.linkTrackEvents = 'None';
	          		s.prop26 = "Fav Board Creations";//New board, log create event
	          		s.tl(true, 'o', 'Fav Board Creations');
	      		}
	    	};
		var viewProductClick = function () {
			var account = s_account ? s_account : "4imprintprod";
			var s = s_gi(account);
			if (typeof s != "undefined") {
		  		s.linkTrackVars = 'eVar36';
		  		s.linkTrackEvents = 'none';
		 		s.eVar36 = "Fav Boards Conversions";//Product click event variable expires at purchase
		  		s.tl(true, 'o', 'Fav Boards Conversions');
			}
	    	};
	    	return {
	      		ViewProductClick: viewProductClick,
	      		LogNewBoardCreation: logNewBoardCreation
	    	};
	},
	
	init = function(){
		checkProdFav();
		favEvents();
	};
	
	return {
		init: init
	};
};

(function(){
	var favHelper = new favoriteHelper();
	favHelper.init();
})();